<p-paginator
  [totalRecords]="totalRecords()"
  [rows]="rows()"
  [first]="first()"
  [rowsPerPageOptions]="rowsPerPageOptions()"
  [showFirstLastIcon]="showFirstLastIcon()"
  [showCurrentPageReport]="showCurrentPageReport()"
  [currentPageReportTemplate]="currentPageReportTemplate()"
  [showPageLinks]="showPageLinks()"
  [showJumpToPageDropdown]="showJumpToPageDropdown()"
  [class]="styleClass()"
  [alwaysShow]="alwaysShow()"
  (onPageChange)="handlePageChange($event)">
</p-paginator>
